export function AnimationOpen({ children, isOpen }: any) {
  return (
    <div
      className={`transition-all duration-500 ${
        isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
      }`}
    >
      {children}
    </div>
  );
}
